import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDfScKbosYFDO_ZTLLIFrJaUrK8KG27g3o",
  authDomain: "synapse-25.firebaseapp.com",
  projectId: "synapse-25",
  storageBucket: "synapse-25.firebasestorage.app",
  messagingSenderId: "573137917985",
  appId: "1:573137917985:web:1950d524f81b42c3a6eb60",
  measurementId: "G-52LF0NP2E8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };
